import { useMemo, useState } from "react";
//bootstrap
import { Badge, Button, Card, Col, Row } from "react-bootstrap";
import { Flex, Subtitle, Title } from "@tremor/react";
//component
import { ActionsModal, TableHeader } from "_components/molecules";
import { ClickableTable } from "_components/organisms";
import RejectReasonsForm from "./reject-reasons-form";
//redux
import { useSelector } from "react-redux";
import { checkIfStaticReasons, selectRejectReasonsByType, selectRejectReasonsStatus } from "_redux/slices/timeline/reject-reasons";
//style
import { SCALE_8 } from "_styles/spacing";
//icons
import { FaCirclePlus } from "react-icons/fa6";
import { MdEdit } from "react-icons/md";
import { DARK_GREEN, PRM_LIGHT_BLUE } from "_styles/colors";

const iconStyles = {
    marginInlineEnd: "20px",
    fontSize: "26px",
    borderRadius: "4px",
    padding: "2px 6px",
    transition: "all 0.3s ease", // Add a smooth transition
};


const getSpanColor = (value) => {
    switch (value) {
        case "ARRIVAL":
            return DARK_GREEN;
        case "DEPARTURE":
            return PRM_LIGHT_BLUE;
        case "BOARDING":
            return "#e895a4";
        case "RAMP":
            return "#456440";
        case "ALT":
            return "#800080";
        case "PAX":
            return "#ebb71c";
        default:
            return "#6c757d"; // fallback grey
    }
};

//local component to display custom span for target/eligible
const RenderOptions = ({ options }) => {
    return (
        <div style={{ display: "flex", marginTop: -6 }}>
            {options.map((option, index) => {
                const color = getSpanColor(option);

                return (
                    <div
                        key={index}
                        style={{
                            display: "flex",
                            marginLeft: index === 0 ? 0 : 5,
                            justifyContent: "left",
                        }}
                    >
                        <span
                            style={{
                                padding: "0.35rem 0.6rem",
                                borderRadius: "8px",
                                backgroundColor: color,
                                color: "#fff",
                                fontSize: "0.75rem",
                                fontWeight: 500,
                                whiteSpace: "nowrap"
                            }}
                        >
                            {option}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

const RejectReasons = () => {

    //#region redux
    const rejectreasons = useSelector((state) => selectRejectReasonsByType(state, "ALL"))            //list of reject reasons array
    const isStaticReasons = useSelector(checkIfStaticReasons);                                       //check if airport has static or custom reject reasons
    const status = useSelector(selectRejectReasonsStatus);                                            //status for getting/posting and patching reject reasons

    const [showModal, setShowModal] = useState(false);                                        //show add/update modal
    const [selectedReason, setSelectedReason] = useState(null);

    //open/close modal, then reset select value if it was valid
    const triggerModal = () => {
        setShowModal(!showModal);
        if (selectedReason) setSelectedReason(null); //this will reset slected reason,
    }

    const handleEdit = (value) => {
        triggerModal();
        setSelectedReason(value);
    }

    const handleAdd = (value) => {
        triggerModal();
    }

    //List of columns to display
    const columns = useMemo(
        () => [

            {
                Header: <TableHeader title={'Reason Label'} />,
                accessor: "label",
                Cell: ({ cell: { value } }) => <p>{value}</p>
            },
            {
                Header: <TableHeader title={'Target'} />,
                accessor: "target",
                Cell: ({ cell: { value } }) => <RenderOptions options={value} />
            },
            {
                Header: <TableHeader title={'Eligible'} />,
                accessor: "eligible",
                Cell: ({ cell: { value } }) => <RenderOptions options={value} />
            },
            {
                Header: <TableHeader title={""} />,
                accessor: "actions",
                // render custom object
                Cell: ({ cell: props }) => (
                    <div style={{ padding: 12, justifyContent: "flex-end", display: "flex" }}>
                        <Button variant="outline-primary" style={iconStyles} >
                            <MdEdit
                                onClick={() => {
                                    handleEdit(props?.row?.original);
                                }}
                            />
                        </Button>
                    </div>
                ),
            }
        ],
        []
    );

    return <>
        <Card>

            <Row>
                <Col className="ml-3">
                    <Flex>
                        {/* title */}
                        <div>
                            <Title>Reject reasons list</Title>
                            <Subtitle>Add, edit and reject reasons to match your requirements </Subtitle>
                            {isStaticReasons && <Subtitle>Please upgrade the reasons list to match your requirements, we are still using a default reasons. </Subtitle>}
                        </div>
                        <div className="d-flex gap-2">
                            <FaCirclePlus
                                onClick={handleAdd}
                                style={{ marginLeft: SCALE_8, cursor: "pointer" }}
                                color={"lightgrey"}
                                size={28}
                            />
                        </div>
                    </Flex>
                </Col>
            </Row>
            <Row>
                <div style={{ overflowY: 'scroll', height: '40em', }}>
                    {
                        <ClickableTable
                            columns={columns}
                            // data={rejectreasons.length ? rejectreasons : []}//hre we can display static data if that makes a sense 
                            data={isStaticReasons ? [] : rejectreasons ?? []}
                            status={status}
                            clickable={false}

                        />
                    }
                </div>

            </Row>

        </Card>

        <ActionsModal
            show={showModal}
            handleClose={triggerModal}
            title={selectedReason ? "Edit selected reason" : "Add new reasons"}
            subtitle={selectedReason ? `You can update details of this reason with affect on old data` : `Add list of reasons to your system, control target and eligible to display them`}
            minWidth="700px"
            maxWidth="700px"
            isTimeline={false}>
            <RejectReasonsForm selectedReason={selectedReason} setShowModal={setShowModal} />

        </ActionsModal>
    </>
}

export default RejectReasons;